import { apiClient, ensureCsrfCookie } from '@/api/client'
import type { ApiSuccessResponse } from '@/types/api'

export interface LmsSource {
  id: number
  code: string
  name: string
  baseUrl: string | null
  apiKey: string
  isActive: boolean
  contactEmail: string | null
  studentProfileCount: number | null
  createdAt: string
}

export interface LmsSourceWithSecret {
  source: LmsSource
  plainSecret: string
}

export const lmsSourcesApi = {
  list: async () => {
    const { data } = await apiClient.get<ApiSuccessResponse<LmsSource[]>>('/admin/lms-sources')
    return data.data
  },

  create: async (payload: { code: string; name: string; base_url?: string; contact_email?: string }) => {
    await ensureCsrfCookie()
    const { data } = await apiClient.post<ApiSuccessResponse<LmsSourceWithSecret>>('/admin/lms-sources', payload)
    return data.data
  },

  activate: async (id: number) => {
    await ensureCsrfCookie()
    const { data } = await apiClient.patch<ApiSuccessResponse<LmsSource>>(`/admin/lms-sources/${id}/activate`)
    return data.data
  },

  deactivate: async (id: number) => {
    await ensureCsrfCookie()
    const { data } = await apiClient.patch<ApiSuccessResponse<LmsSource>>(`/admin/lms-sources/${id}/deactivate`)
    return data.data
  },

  regenerateSecret: async (id: number) => {
    await ensureCsrfCookie()
    const { data } = await apiClient.post<ApiSuccessResponse<LmsSourceWithSecret>>(
      `/admin/lms-sources/${id}/regenerate-secret`,
    )
    return data.data
  },
}
